import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Cidade } from '@app/models/cidade';
import { CidadeService } from '@app/services/cidade.service';

@Component({
  selector: 'app-cidade-form',
  templateUrl: './cidade-form.component.html'
})
export class CidadeFormComponent implements OnInit {

  aguardandoSolicitacao : boolean = false;
  titulo: string;
  lstErros: string[];
  cidade: Cidade = new Cidade();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cidadeService: CidadeService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const id = params['id'];
      this.titulo = id ? 'Editar Cidade' : 'Nova Cidade';

      if (!id) {
        return;
      }

      this.cidadeService.obterPorId(id).toPromise().then(
        data => this.cidade = data,
        () => this.router.navigate(['./configuracoes/cidade']));
    });
  }

  onSubmit() {
    this.aguardandoSolicitacao = true;
    this.cidadeService.gravar(this.cidade).toPromise().then(
      () => this.router.navigate(['./configuracoes/cidade']),
      (data: any) => {
        if (data.error) {
          this.lstErros = data.error.errors;
        }
        this.aguardandoSolicitacao = false;
      });
  }
}
